import {
    FJViewCanvasSingleton,
    MOUSE_EVENT_TYPE,
} from '../../components/FJMainPreview/FJCreationEditPanel/js/FJViewCanvas';
import FJConstant from '../../constants/FJConstant';
import FJLocalStore from '../../store/FJLocalStore';
import FJMessageStore from '../../store/FJMessageStore';
import FJNetworkStore from '../../store/FJNetworkStore';
import FJFileHandleUtil from '../../util/FJFileHandleUtil';
import FJUtil from '../../util/FJUtil';
import { setSliceAiMaskActive, setSliceDisableCompare } from '../slices/FJSliceBrushEditCommon';
import { setSliceCreationListAction, setSliceTaskStatusAction } from '../slices/FJSliceCommon';
import { setSliceInputImageInfo } from '../slices/FJSliceObjectErase';
import FJActionBrushEditCommon from './FJActionBrushEditCommon';
import FJActionCommon from './FJActionCommon';
import FJActionModal from './FJActionModal';
import FJImageStore from '../../store/FJImageStore';
import FJLoadLocalforageStore from '../../store/FJLoadLocalforageStore';
import FJCompressedImageStore from '../../store/FJCompressedImageStore';
import { MAX_COMPRESS_IMAGE_SIZE } from '../../config/dataConfig/FJGenerateData.js';
import FJCpmpressedImageStore from '../../store/FJCompressedImageStore.js';

const FJActionObjectErase = {
    resetAction: function () {
        return dispatch => {
            dispatch(setSliceInputImageInfo(null));
            dispatch(FJActionBrushEditCommon.setEditImageAction(null));
            FJViewCanvasSingleton.clear();
        };
    },
    /**
     * 上传图片
     * @param {File} file
     */
    uploadImageAction: function (file) {
        return async dispatch => {
            const isGif = FJFileHandleUtil.isGIF(file);
            if (isGif) {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
                return;
            }

            try {
                const imageInfo = await FJCompressedImageStore.compressImageByFile(file);
                if (!imageInfo) {
                    throw new Error('compress image failed');
                }

                dispatch(setSliceCreationListAction([]));
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));

                setTimeout(() => {
                    dispatch(setSliceAiMaskActive(true));
                    dispatch(setSliceInputImageInfo(imageInfo));
                    dispatch(FJActionBrushEditCommon.setCurBrushTypeAction(MOUSE_EVENT_TYPE.QUICK_SELECTION));
                    dispatch(FJActionBrushEditCommon.setEditImageAction(imageInfo));
                }, 200);
            } catch (error) {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
            }
        };
    },
    uploadImageUrlAction: function (url, options) {
        return async dispatch => {
            try {
                const { size, name, id } = options;
                let data;
                if (size.width > MAX_COMPRESS_IMAGE_SIZE || size.height > MAX_COMPRESS_IMAGE_SIZE) {
                    data = await FJCpmpressedImageStore.compressImageByUrl(url, { name: name }).catch(() => {
                        throw new Error('compress image failed');
                    });
                } else {
                    data = { name: name, src: url, width: size.width, height: size.height, id: id };
                }

                dispatch(setSliceCreationListAction([]));
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));

                setTimeout(() => {
                    dispatch(setSliceAiMaskActive(true));
                    dispatch(setSliceInputImageInfo(data));
                    dispatch(FJActionBrushEditCommon.setEditImageAction(data));
                }, 200);
            } catch (error) {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
            }
        };
    },

    /**
     * @desc 物体抹除生成
     */
    generateAction: function () {
        return async (dispatch, getState) => {
            const { inputImageInfo } = getState().objectErase;
            const { creditNumber, freeNumCreation } = getState().common;

            let way = '';
            FJViewCanvasSingleton.getMaskUseSituation().then(maskUseSituation => {
                const { maskIsUse, aiMaskIsUse } = maskUseSituation;
                maskIsUse && (way += 'brush');
                aiMaskIsUse && (way += maskIsUse ? '、auto selection' : 'auto selection');
                FJUtil.eaLog('object remover remove click', {
                    way,
                });
            });

            const __errorCallback = (isShowMessage = true) => {
                if (isShowMessage) {
                    FJMessageStore.addMessage(FJLocalStore._('failed-to-remove-please-try-again'), 'error');
                }
                dispatch(setSliceCreationListAction([]));
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
            };

            const __errorAndReLoad = () => {
                const creationList = getState().common.creationList;
                const reLoadList = creationList.map(i => ({
                    ...i,
                    isLoading: false,
                    isReload: true,
                }));
                dispatch(setSliceCreationListAction(reLoadList));
                dispatch(setSliceTaskStatusAction(FJConstant.ERROR));
            };

            const __judgeCanGenerate = async () => {
                const userSpaceType = await FJUtil.checkUserSpace({
                    errorCallback: () => {
                        FJMessageStore.addMessage(FJLocalStore._('failed-to-remove-please-try-again'), 'error');
                    },
                });
                if (userSpaceType > 0) {
                    dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                    return false;
                }

                const useCredit = 3;

                //免费判断
                const canFreeCreate = freeNumCreation;

                if (creditNumber < useCredit && !canFreeCreate) {
                    dispatch(FJActionModal.showUpgradeModalAction());
                    return false;
                }
                // isFree = creditNumber < useCredit && canFreeCreate;
                return true;
            };

            // 1. 先给反馈开始状态修改
            const placeHolderList = FJUtil.createPlaceHolderListNew({
                count: 1,
                width: inputImageInfo.width,
                height: inputImageInfo.height,
                type: FJConstant.CREATIONS,
            });
            dispatch(FJActionCommon.setHeaderTabIndexAction(0));
            dispatch(setSliceCreationListAction(placeHolderList));
            dispatch(setSliceTaskStatusAction(FJConstant.START));

            // 1. 检查编辑图是否准备好
            const editImageBlob = await FJViewCanvasSingleton.getEditImageBlob();
            const originImageBlob = await FJViewCanvasSingleton.getOriginImageBlob();

            if (!editImageBlob || !originImageBlob) {
                __errorCallback();
                return;
            }

            // 3.检查登录、积分
            const canGenerate = await __judgeCanGenerate();
            if (!canGenerate) {
                __errorCallback(false);
                return;
            }

            try {
                const maskBlob = await FJViewCanvasSingleton.getMaskImageBlob();
                if (!maskBlob) {
                    __errorCallback();
                    return;
                }

                const editImageS3Url = await FJImageStore.uploadFileByBlob(editImageBlob);
                const originImageS3Url = await FJImageStore.uploadFileByBlob(originImageBlob);

                const maskUrl = await FJImageStore.uploadFileByBlob(maskBlob);

                if (!editImageS3Url || !originImageS3Url || !maskUrl) {
                    __errorCallback();
                    return;
                }

                const __request = async () => {
                    return await FJNetworkStore.objectEraserTask({
                        image: editImageS3Url,
                        mask: maskUrl,
                        original_image: originImageS3Url,
                        prompt: window._prompt || '',
                    });
                };

                const __callback = data => {
                    const { type, waitingEndTime } = data;

                    if (type === FJConstant.ERROR) {
                        __errorAndReLoad();
                    }

                    if (type === FJConstant.SUCCESS) {
                        const creationList = getState().common.creationList;
                        const { aiMaskActive } = getState().brushEditCommon;

                        // 成功后替换编辑区域图片
                        if (creationList.length > 0 && !FJUtil.isMobile()) {
                            const creation = creationList[0];
                            dispatch(FJActionBrushEditCommon.resetMaskAction());
                            dispatch(setSliceDisableCompare(false));

                            aiMaskActive && dispatch(FJActionBrushEditCommon.setAiMaskActive(false));
                            dispatch(
                                FJActionBrushEditCommon.setEditImageAction({
                                    src: creation.imgUrl,
                                    creationId: creation.id,
                                    width: creation.width,
                                    height: creation.height,
                                }),
                            );
                        }

                        let _endTime = new Date().getTime();
                        const generatingDuration = FJUtil.getTimeDiff(waitingEndTime, _endTime);

                        FJUtil.eaLog('object remover generate success', {
                            'generating duration': generatingDuration,
                            way,
                        });
                        FJUtil.eaLog('ai tool generate success', {
                            tool: FJUtil.getToolName(),
                            'credit&free': isFree ? 'free' : 'credit',
                        });
                    }
                };

                const eventId = await FJActionCommon.createRequestTask(__request, dispatch);
                dispatch(FJActionCommon.updateFreezeInfoAction());
                const isFree = creditNumber < 3 && freeNumCreation > 0;
                const tool = FJUtil.getToolName();
                FJUtil.eaLog('ai tool start generating', { 'credit&free': isFree ? 'free' : 'credit', tool });
                dispatch(
                    FJActionCommon.pollingTaskAction([eventId], {
                        callback: __callback,
                        progressNumber: 1,
                        autoDefaultTaskStatus: !FJUtil.isMobile(),
                    }),
                );
            } catch (error) {
                __errorCallback();
            }
        };
    },

    /**
     * @desc 下载图片
     */
    downloadEditImageAction: function () {
        return async (dispatch, getState) => {
            const { editImage } = getState().brushEditCommon;
            if (!editImage || !editImage.creationId) return;
            dispatch(FJActionCommon.multiDownloadAction([editImage.creationId], 'creation'));
        };
    },

    /**
     * @desc 重新生成
     */
    reGenerateAction: function () {
        return async dispatch => {
            dispatch(this.generateAction());
        };
    },

    /**
     * @desc 初始化物体抹除项目
     */
    initObjectEraseProjectAction: function () {
        return async dispatch => {
            const recId = FJUtil.getQueryString(FJConstant.REC_ID);
            const recIdInfo = recId ? JSON.parse(window.localStorage.getItem(recId)) : null;
            if (recIdInfo) {
                const url = location.origin + location.pathname;
                FJUtil.changeLocation(url);
                window.localStorage.removeItem(recId);
                const { fileList, avator } = recIdInfo;

                if (fileList) {
                    const fileInfo = fileList[0]?.info;
                    if (!fileInfo) return;
                    const data = await FJLoadLocalforageStore.getItem(fileList[0].key);
                    const file = new File([data.data], fileInfo.name, { type: fileInfo.type });
                    dispatch(this.uploadImageAction(file));
                } else if (avator) {
                    const blob = await FJUtil.getBlobByUrl(avator);
                    dispatch(this.uploadImageAction(blob));
                }
            }
        };
    },

    /**
     * @desc 编辑图片加载完成后后执行
     * @returns
     */
    updateEditImageAfterAction: function () {
        return async (dispatch, getState) => {
            const { aiMaskActive } = getState().brushEditCommon;

            const inputImageInfo = getState().objectErase.inputImageInfo;
            if (inputImageInfo) {
                dispatch(FJActionBrushEditCommon.setOriginImageAction(inputImageInfo));
                dispatch(FJActionBrushEditCommon.updateDisableCompareAction());
            }

            if (aiMaskActive) {
                dispatch(
                    FJActionBrushEditCommon.initAiMaskCanvas(() => {
                        FJUtil.isMobile() && FJViewCanvasSingleton.draw();
                    }),
                );
            }
        };
    },
};

export default FJActionObjectErase;
